/* eslint-disable react/display-name */

import React, { forwardRef } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import Hour from './hour';
import { padZero } from '../../utils';

const TimeScaleHeader = forwardRef((props, ref) => {
  const {
    startHour,
    endHour
  } = props;

  const styles = StyleSheet.create({
    timeScaleContainer: {
      display: 'flex',
      height: '100%',
      paddingBottom: '1px',
      alignItems: 'flex-end',
      paddingLeft: '8px'
    }
  });

  const hours = [];
  for (let i = startHour; i <= endHour; i++) {
    hours.push(
      <Hour
        key={`${i}__hour`}
        label={`${padZero(i)}00`}
        hourWidth={props.hourWidth}
      />
    );
  }

  return (
    <div
      className={css(styles.timeScaleContainer)}
      ref={ref}
    >
      {hours}
    </div>
  );
})

export default TimeScaleHeader;
